export const openPlaceholderTab = () => {
  const placeholder = window.open("", "_blank");
  if (placeholder) placeholder.opener = null;

  return {
    navigate: (url: string) => {
      if (placeholder) placeholder.location.href = url;
      else window.open(url, "_blank", "noopener,noreferrer");
    },
    close: () => placeholder?.close(),
  };
};
